import React from "react";
import "./Bank_Account.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function Bank_Account() {
  const navigate = useNavigate();
  return (
    <section className="Bank_Account">
      <Common_white_header headingText={"Bank Account"} />

      <div className="container">
        {/* Bank Details Card */}
        <div className="bank-details-card">
          <div className="bank-row">
            <span className="label">Bank name</span>
            <span className="value">State Bank Of India</span>
          </div>

          <div className="bank-row">
            <span className="label">Bank Account number</span>
            <span className="value">2428678***0827</span>
          </div>

          <div className="bank-row">
            <span className="label">Phone number</span>
            <span className="value">+91 2679390****</span>
          </div>

          <div className="bank-row">
            <span className="label">IFSC Code</span>
            <span className="value">SBIN00013725</span>
          </div>
        </div>

        {/* Add Bank Section */}
        <div className="add-bank-section">
          <div
            className="plus-circle"
            onClick={() => navigate("/add-bank-account")}
          >
            <FaPlus />
          </div>

          <button
            className="btn_register_bg"
            onClick={() => navigate("/add-bank-account")}
          >
            Add a Bank Account
          </button>
        </div>
      </div>
    </section>
  );
}

export default Bank_Account;
